var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 82,
    viewBox: "0 0 84 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7312_2816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6101 40.99L70.3101 30.5V38.48H38.8701V43.51H70.3101V51.48L83.6101 40.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0402 0H40.9302C29.8802 0.03 19.5402 4.35 11.8102 12.18C4.08016 20 -0.109841 30.38 0.000158933 41.41C0.230159 63.78 18.6302 81.98 41.0302 81.98C54.9202 81.98 67.7202 75.07 75.3502 63.47H68.8902C68.7202 63.47 68.5702 63.54 68.4702 63.67C67.7602 64.53 67.0002 65.36 66.2102 66.14C62.9502 69.4 59.1402 71.97 54.8902 73.76C50.5002 75.61 45.8602 76.55 41.0902 76.55H41.0302C36.2302 76.55 31.5702 75.61 27.1802 73.76C22.9302 71.97 19.1202 69.4 15.8602 66.13C12.5902 62.88 10.0202 59.07 8.23016 54.83C6.38016 50.46 5.44016 45.8 5.44016 40.98C5.44016 36.16 6.38016 31.53 8.23016 27.13C10.0202 22.9 12.5902 19.09 15.8702 15.82C19.1602 12.54 22.9702 9.98 27.1902 8.19C31.5802 6.34 36.2402 5.4 41.0502 5.4C45.8602 5.4 50.5402 6.34 54.9102 8.19C59.1302 9.97 62.9402 12.54 66.2302 15.81C66.9702 16.55 67.7002 17.35 68.4802 18.27C68.5902 18.41 68.7502 18.48 68.9202 18.48H75.3802C67.7202 6.9 54.9302 0 41.0402 0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7312_2816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.61,
    height: 81.98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.60ed4ddfa8fe7837f487e4cb6967c2cb.svg";
export { ForwardRef as ReactComponent };